import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAllInvoiceSelector } from "../store/invoiceSlice";
import subscriptionService from "../services/subscriptionService";

// Helper to get days between two dates
function daysBetween(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24));
}

export default function useNotifications() {
  const invoices = useSelector(getAllInvoiceSelector);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const today = new Date();
    let notifs = [];

    // Unpaid invoice due notifications (only one per due event)
    invoices.forEach((inv) => {
      if (inv.statusName === "Unpaid" && inv.dueDate) {
        const daysLeft = daysBetween(today, inv.dueDate);
        if (daysLeft === 7) {
          notifs.push({
            type: "invoice_due",
            message: `Invoice #${inv.invoiceNo} is due in 1 week.`,
            id: `due-7-${inv.id}`
          });
        } else if (daysLeft <= 3 && daysLeft > 0) {
          notifs.push({
            type: "invoice_due",
            message: `Invoice #${inv.invoiceNo} is due in ${daysLeft} day(s)!`,
            id: `due-3-${inv.id}`
          });
        } else if (daysLeft === 0) {
          notifs.push({
            type: "invoice_due",
            message: `Invoice #${inv.invoiceNo} is due today!`,
            id: `due-today-${inv.id}`
          });
        }
      }
    });

    // Subscription ending notification (only one per event)
    const sub = subscriptionService.getCurrentSubscription();
    if (sub && sub.endDate) {
      const daysLeft = daysBetween(today, sub.endDate);
      if (daysLeft === 7) {
        notifs.push({
          type: "subscription_end",
          message: `Your subscription ends in 1 week! Renew soon to avoid interruption.`,
          id: `sub-7`
        });
      } else if (daysLeft <= 3 && daysLeft > 0) {
        notifs.push({
          type: "subscription_end",
          message: `Your subscription ends in ${daysLeft} day(s)! Renew now!`,
          id: `sub-3`
        });
      } else if (daysLeft === 0) {
        notifs.push({
          type: "subscription_end",
          message: `Your subscription ends today! Renew now to keep access.`,
          id: `sub-today`
        });
      }
    }

    setNotifications(notifs);
  }, [invoices]);

  return notifications;
}
